import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 22.75C11.76 22.75 11.52 22.72 11.29 22.65C6.10003 21.22 2.34003 16.37 2.34003 11.11V6.72C2.34003 5.6 3.15003 4.39 4.19003 3.96L9.76003 1.68C11.1951 1.0899 12.805 1.0899 14.24 1.68L19.81 3.96C20.85 4.39 21.66 5.6 21.66 6.72V11.11C21.66 16.36 17.89 21.21 12.71 22.65C12.48 22.72 12.24 22.75 12 22.75ZM12 2.75C11.4272 2.75024 10.8599 2.86234 10.33 3.08L4.76003 5.36C4.28003 5.56 3.84003 6.21 3.84003 6.73V11.12C3.84003 15.71 7.14003 19.95 11.69 21.21C11.89 21.27 12.11 21.27 12.31 21.21C16.86 19.95 20.16 15.71 20.16 11.12V6.73C20.16 6.21 19.72 5.56 19.24 5.36L13.67 3.08C13.1401 2.86234 12.5729 2.75024 12 2.75Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 13.25C10.48 13.25 9.25 12.02 9.25 10.5C9.25 8.98 10.48 7.75 12 7.75C13.52 7.75 14.75 8.98 14.75 10.5C14.75 12.02 13.52 13.25 12 13.25ZM12 9.25C11.6685 9.25 11.3505 9.3817 11.1161 9.61612C10.8817 9.85054 10.75 10.1685 10.75 10.5C10.75 10.8315 10.8817 11.1495 11.1161 11.3839C11.3505 11.6183 11.6685 11.75 12 11.75C12.3315 11.75 12.6495 11.6183 12.8839 11.3839C13.1183 11.1495 13.25 10.8315 13.25 10.5C13.25 10.1685 13.1183 9.85054 12.8839 9.61612C12.6495 9.3817 12.3315 9.25 12 9.25Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 16.25C11.59 16.25 11.25 15.91 11.25 15.5V12.5C11.25 12.09 11.59 11.75 12 11.75C12.41 11.75 12.75 12.09 12.75 12.5V15.5C12.75 15.91 12.41 16.25 12 16.25Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }